import getEnv from "env";

export const assetsBasePart = `${getEnv().assetServicePath}/v1`;
export const authBasePart = `${getEnv().identityServicePath}`;
export const identityBasePart = `${getEnv().identityServicePath}/v1`;
export const workflowBasePart = `${getEnv().workflowServicePath}/v1`;
export const notificationsBasePart = `${getEnv().notificationsServicePath}/v1`;
export const trackingBasePart = `${getEnv().trackingServicePath}/v1`;
